import React from 'react';
import Application_check from './Application_check';


const Main = () => {
return(

<Application_check/>
)
};

export default Main;
